import { CrossCircledIcon } from '@radix-ui/react-icons';
import { ComponentProps, forwardRef } from 'react';
import cn from '../../app/utils/cn';

interface IInputProps extends ComponentProps<'input'> {
  name: string;
  error?: string;
  children?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(
  ({ placeholder, name, id, error, children, className, ...props }, ref) => {
    const inputId = id ?? name;

    return (
      <div className="relative w-full">
        <input
          className={cn(
            'bg-surface-input border-border-input text-text-primary peer/input h-10 w-full rounded border-2 border-solid px-2 pt-4 text-sm shadow-md outline-none placeholder-shown:pt-0 autofill:pt-4 focus:border-green-600 disabled:opacity-50 dark:focus:border-green-400',
            !!error && '!border-red-500',
            className,
          )}
          ref={ref}
          name={name}
          id={inputId}
          placeholder=""
          {...props}
        />
        <label
          className="text-text-disabled dark:text-grey-300 pointer-events-none absolute top-1 left-2.5 text-xs transition-all duration-300 ease-in-out peer-placeholder-shown/input:top-1/2 peer-placeholder-shown/input:-translate-y-1/2 peer-placeholder-shown/input:text-sm peer-autofill/input:top-1 peer-autofill/input:translate-y-0 peer-autofill/input:text-xs peer-disabled/input:opacity-50"
          htmlFor={inputId}
        >
          {placeholder}
        </label>
        {error && (
          <div className="mt-1 flex items-center gap-1 text-xs text-red-500 dark:text-red-400">
            <CrossCircledIcon />
            <small>{error}</small>
          </div>
        )}
        {children}
      </div>
    );
  },
);

Input.displayName = 'Input';
